export default __webpack_public_path__ + "static/media/yahoo.946fe585.svg";